module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Devices/Apple-Watch-750b0095e21b07bc111732901f4f1074.svg";